<template>
  <div class="ac3">
    <div class="ac3_item">
      <img class="ac3_item_bg" src="../../assets/2022ac/03/2.png" />
      <div class="ac3_block">
        <div class="ac3_block_title">斐燃生活</div>
        <div class="ac3_block_item">
          <img class="ac3_block_code" src="../../assets/2022ac/03/1.jpg" />
          <div class="ac3_block_tips">点击跳转【斐燃生活】小程序</div>
          <div @click="toWeChat()" class="ac3_block_btn">立即跳转</div>
        </div>
      </div>
    </div>

    <!-- <van-popup v-model:show="ac3_popup">内容</van-popup> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        // ac3_popup:true
      }
    },
    created() {

    },
    mounted() {
      this.toWeChat()
      // this.$dialog.confirm({
      //   title: '温馨提示',
      //   message:
      //     '立即前往《斐燃生活》微信小程序',
      // })
      //   .then(() => {
      //     this.toWeChat()
      //     // on confirm
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
      // this.toWeChat()
    },
    methods: {
      toWeChat(){
        // console.log('前往微信小程序-回归好礼页面')
        window.location.href='weixin://dl/business/?t=uG2QuotOB7l'
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  html,body{
    padding: 0;
    margin: 0;
  }
  .ac3{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(../../assets/2022ac/03/5.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .ac3_item{
      width: calc(100% - 230*@vm_base);
      position: relative;
      padding:0 0 30*@vm_base 0;
      .ac3_block{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        .ac3_block_title{
          width: calc(100% - 60*@vm_base);
          margin-left: 30*@vm_base;
          border-bottom: 1*@vm_base dashed #979797;
          height: 160*@vm_base;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 40rpx;
          font-weight: 600;
          color: #000000;
        }
        .ac3_block_item{
          width: 100%;
          padding: 60*@vm_base 0 0 0;
          text-align: center;
          .ac3_block_code{
            width: 190*@vm_base;
            height: 190*@vm_base;
            margin: 0 auto;
          }
          .ac3_block_tips{
            width: 100%;
            font-size: 26rpx;
            font-weight: 500;
            color: #666666;
            line-height: 1.85;
            text-align: center;
            margin: 28*@vm_base 0 60*@vm_base 0;
          }
          .ac3_block_btn{
            width: 340*@vm_base;
            height: 80*@vm_base;
            margin: 0 auto;
            background: linear-gradient(142deg, #0A0A0A 0%, #4B3D31 100%);
            border-radius: 8*@vm_base;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 32rpx;
            font-weight: 600;
            color: #FFFFFF;
            letter-spacing: 2px;
          }
        }
      }
    }
    .ac3_item_bg{
      width: 100%;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/ac/acRegressionGift.vue